import type { ConversationMessage } from '../../types/ai-sales-chat';
import { toMillisSafe } from '../../lib/utils/timestamp';

/**
 * Ascending by createdAt; for the same time the user message comes before the assistant's.
 * A message whose time cannot be read sorts LAST (it is the one just sent), never first and never given a made-up time.
 */
export function compareMessagesByTime(a: ConversationMessage, b: ConversationMessage): number {
  const aTime = toMillisSafe(a.createdAt) ?? Number.POSITIVE_INFINITY;
  const bTime = toMillisSafe(b.createdAt) ?? Number.POSITIVE_INFINITY;
  if (aTime !== bTime) return aTime < bTime ? -1 : 1;
  if (a.role === 'user' && b.role !== 'user') return -1;
  if (b.role === 'user' && a.role !== 'user') return 1;
  return 0;
}
